export const PRODUCT_STATUS_ACTIVE = 1;
export const PRODUCT_STATUS_PAUSED = 2;
export const PRODUCT_STATUS_DELETED = 3;